import { render, staticRenderFns } from "./AmexCredsHelpPopup.vue?vue&type=template&id=2906a5ca&scoped=true"
import script from "./AmexCredsHelpPopup.vue?vue&type=script&lang=js"
export * from "./AmexCredsHelpPopup.vue?vue&type=script&lang=js"
import style0 from "./AmexCredsHelpPopup.vue?vue&type=style&index=0&id=2906a5ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2906a5ca",
  null
  
)

export default component.exports